import Vue from "vue";
import VueGtag from "vue-gtag";
import router from "@/router";

export default {
  setGtag(gaId) {
    Vue.use(
      VueGtag,
      {
        config: { id: gaId }
      },
      router
    );
  }
};
